export default {"src":"/_next/static/media/logo.09e24f0b.svg","height":26,"width":81,"blurWidth":0,"blurHeight":0};